import React, { useState, useEffect } from "react";
import HHForm from "./HHForm";
import {
  Grid,
  Select,
  MenuItem,
  FormControl,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getFacilities } from "../../../service/endpoint-manager";

import styles from "../../../styles.module.css";

import { MAX_DROPDOWN_HEIGHT } from "../../../types/micellinous-constants";

const useStyles = makeStyles((theme) => ({
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  whiteBackgroundBox: {},
}));

const HandHygieneForm = () => {
  const classes = useStyles();
  const user = JSON.parse(localStorage.getItem("user-profile"));
  const nurse = user ? user.userName : "";

  const [facilities, setFacilities] = useState([]);
  const [units, setUnits] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await getFacilities();
        if (response.data.status) {
          setFacilities(response.data.body);
        }
      } catch (error) {
        console.error("Error fetching facilities: ", error);
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const selectedFacilityData = facilities.find(
      (facility) => facility.name === selectedFacility
    );

    setUnits(selectedFacilityData ? selectedFacilityData.units : []);
  }, [selectedFacility, facilities]);

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        style={{ marginBottom: "2rem", marginTop: "2rem" }}
        className={styles.whiteBackgroundBox}
      >
        <Grid item xs={12} sm={4} className={styles.flexSpaceBetween}>
          <p className={classes.labelDetailStyles}>Nurse</p>
          <FormControl variant="outlined" style={{ width: "80%" }}>
            <TextField
              value={nurse}
              label="Nurse"
              disabled
              fullWidth
              variant="outlined"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} className={styles.flexSpaceBetween}>
          <p className={classes.labelDetailStyles}>Facility</p>
          <FormControl variant="outlined" style={{ width: "80%" }}>
            <Select
              value={selectedFacility}
              onChange={(e) => setSelectedFacility(e.target.value)}
            >
              {facilities.map((facility) => (
                <MenuItem key={facility.name} value={facility.name}>
                  {facility.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} className={styles.flexSpaceBetween}>
          <p className={classes.labelDetailStyles}>Unit</p>
          <FormControl variant="outlined" style={{ width: "80%" }}>
            <Select
              value={selectedUnit}
              onChange={(e) => setSelectedUnit(e.target.value)}
              disabled={!selectedFacility}
              MenuProps={{
                style: {
                  maxHeight: MAX_DROPDOWN_HEIGHT,
                },
              }}
            >
              {units.map((unit) => (
                <MenuItem key={unit.id} value={unit.name}>
                  {unit.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        {[...Array(4)].map((_, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <HHForm
              nurse={nurse}
              facility={selectedFacility}
              unit={selectedUnit}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default HandHygieneForm;
